import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalDescription,
  ModalHeader,
  Cross,
  Space,
  Button,
} from '@cashfree-intl/coherent';

const EndFreeTrial = ({ closeModal, freeTrialObj, endFreeTrail }) => (
  <Modal open $maxWidth="480">
    <ModalHeader>
      End Free Trial{' '}
      <Cross
        onClick={closeModal}
        data-event-name="Form_EndFreeTrial_Icon_Click"
        data-ignore-inner-text="true"
      />
    </ModalHeader>
    <ModalContent>
      <ModalDescription>
        <p>
          Your {freeTrialObj.availableCount} free withdrawals remain. Are you
          sure you want to end the free trial and withdraw settlements of higher
          amount?
        </p>
      </ModalDescription>
      <Space
        gap={4}
        alignItems="center"
        justifyContent="flex-end"
        className="mb-1 mt-4"
      >
        <Button
          className="p-0"
          type="button"
          link
          onClick={closeModal}
          data-event-name="Form_EndFreeTrail_Button_Cancel"
        >
          Cancel
        </Button>
        <Button
          primary
          type="button"
          onClick={endFreeTrail}
          data-event-name="Primary_Button_EndFreeTrail"
        >
          End Free Trial
        </Button>
      </Space>
    </ModalContent>
  </Modal>
);

EndFreeTrial.propTypes = {
  closeModal: PropTypes.func.isRequired,
  endFreeTrail: PropTypes.func.isRequired,
  freeTrialObj: PropTypes.object.isRequired,
};

export default EndFreeTrial;
